import { Pagination, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch } from "react-redux";

import EditBilling from "../Modals/EditBilling";
import { formatNumber } from "../../utils/convertToNumber";
import { deleteBillingTransaction } from "../../redux2/billing/billingSlice";
import AmendTransaction from "../Modals/AmendTransaction";
import AddRemarks from "../Modals/AddRemarks";
import ViewRemarkTransaction from "../Modals/ViewRemarkTransaction";

const Overall = ({ billings, currentPage, setCurrentPage }) => {
  // const billingPerPage = 10;

  const currentBillings = billings?.billings?.data;

  // const indexOfLastProduct = currentPage * billingPerPage;
  // const indexOfFirstProduct = indexOfLastProduct - billingPerPage;
  // const currentBillings = billings?.billings?.data?.slice(
  //   indexOfFirstProduct,
  //   indexOfLastProduct
  // );

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const dispatch = useDispatch();
  const isAmendableTransaction = (billing) => {
    return billing?.type === "deposit";
  };

  const getStatusBadge = (title) => {
    return (
      <span className="absolute -top-1 left-4 px-1 py-0.5 font-semibold text-white bg-red-500 rounded-full text-[7px]">
        {title}
      </span>
    );
  };

  const handleDelete = (item) => {
    confirmAlert({
      title: "Confirm to delete",
      message: `Are you sure to delete this transaction.`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteBillingTransaction(item._id));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body" style={{ padding: "1.25rem" }}>
            <div className="table-responsive">
              <table className="table mb-0 text-xs table-sm table-responsive-lg default-table dataTable">
                <thead>
                  <tr className="text-black">
                    {/* <th></th> */}
                    <th className="align-middle">#</th>
                    <th className="align-middle">Action</th>
                    <th className="align-middle">Status</th>
                    <th className="align-middle">Created At</th>
                    <th className="align-middle">Company Name</th>
                    <th className="align-middle">Transaction ID</th>
                    <th className="align-middle">Ticket Number</th>
                    <th className="align-middle">Payment Method</th>
                    <th className="align-middle">Deposit Amount</th>
                    <th className="pr-7 align-middle">Total Price</th>
                    <th className="pr-7 align-middle">System Fare</th>
                    <th className="align-middle">Sterling S.C</th>
                    <th className="align-middle">NDC S.C</th>
                    <th className="align-middle">System Fee</th>
                    <th className="align-middle">Net Revenue</th>
                    {/* <th className="align-middle">Agent Fee</th> */}
                    <th className="align-middle">Passenger Name</th>
                    <th className="align-middle">From Ticket Number</th>
                    <th className="align-middle">Tax</th>
                    <th className="align-middle">Penalty</th>
                    <th className="align-middle">Used Fare</th>
                    <th className="align-middle">Fare Difference</th>
                    <th className="align-middle">Reason</th>
                    <th className="align-middle">Withdrawn By</th>
                    <th className="align-middle">Cheque Number</th>
                    <th className="align-middle">Paid By</th>
                    <th className="align-middle">Approved By</th>
                    <th className="align-middle">Balance</th>
                    <th className="no-sort" />
                  </tr>
                </thead>
                <tbody id="orders">
                  {currentBillings?.length === 0 ? (
                    <tr>
                      <td colSpan={11}>
                        <Typography variant="h5">No Billing Found</Typography>
                      </td>
                    </tr>
                  ) : (
                    currentBillings?.map((item, index) => (
                      <tr className="btn-reveal-trigger" key={index}>
                        <td>
                          {
                            <p className="flex relative gap-1">
                              {index +
                                1 +
                                (currentPage - 1) *
                                  billings?.billings?.pagination?.limit}{" "}
                              {item?.remark && (
                                <span title="Remark">
                                  {getStatusBadge("RM")}
                                </span>
                              )}
                              {item?.billingReference && (
                                <span title="Amendment">
                                  {getStatusBadge("AM")}
                                </span>
                              )}
                              {item?.isUpdated && (
                                <span title="Updated">
                                  {getStatusBadge("UP")}
                                </span>
                              )}
                            </p>
                          }
                        </td>
                        <td className="py-2">
                          <Dropdown className="dropdown text-sans-serif">
                            <Dropdown.Toggle
                              // id="dropdown"
                              variant=""
                              className="text-primary hover:bg-main-200 i-false tp-btn-light sharp"
                              type="button"
                              id="order-dropdown-0"
                              data-toggle="dropdown"
                              data-boundary="viewport"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    strokeWidth={1}
                                    fill="none"
                                    fillRule="evenodd"
                                  >
                                    <rect x={0} y={0} width={24} height={24} />
                                    <circle
                                      fill="#000000"
                                      cx={5}
                                      cy={12}
                                      r={2}
                                    />
                                    <circle
                                      fill="#000000"
                                      cx={12}
                                      cy={12}
                                      r={2}
                                    />
                                    <circle
                                      fill="#000000"
                                      cx={19}
                                      cy={12}
                                      r={2}
                                    />
                                  </g>
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              className="py-0 border dropdown-menu dropdown-menu-right"
                              aria-labelledby="order-dropdown-0"
                            >
                              <button className="dropdown-item">
                                <EditBilling billing={item} />
                              </button>
                              {isAmendableTransaction(item) &&
                                !item?.billingReference && (
                                  <button className="dropdown-item">
                                    <AmendTransaction billing={item} />
                                  </button>
                                )}
                              <button className="dropdown-item">
                                <AddRemarks billing={item} />
                              </button>
                              {item.remark && (
                                <button className="dropdown-item">
                                  <ViewRemarkTransaction
                                    remark={item.remark}
                                    reference={item.billingReference}
                                  />
                                </button>
                              )}
                              {item?.type === "deposit" &&
                                item?.bank === "short-term-credit" && (
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleDelete(item)}
                                  >
                                    <span className="text-red-500 hover:text-red-700">
                                      Delete Transaction
                                    </span>
                                  </button>
                                )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                        <td>
                          {item?.type === "refundDeposit" ? (
                            <span className="bg-red-600 badge">
                              Refund Deposit
                            </span>
                          ) : item?.type === "voidDeposit" ? (
                            <span className="bg-blue-600 badge">
                              Void Deposit
                            </span>
                          ) : item?.type === "STCreditSettlement" ? (
                            <span className="bg-sky-600 badge">
                              Short-term Payment
                            </span>
                          ) : item?.reason ? (
                            <span className="badge badge-info">
                              Credit Payment
                            </span>
                          ) : item?.deposit ? (
                            <span className="badge badge-dark">
                              Wallet Deposit
                            </span>
                          ) : item?.status === "refunded" ? (
                            <span className="badge badge-danger">Refunded</span>
                          ) : item?.status === "voided" ? (
                            <span className="badge badge-secondary">Void</span>
                          ) : item?.status === "void-late" ? (
                            <span className="badge badge-secondary">
                              Void-Late
                              <span className="ms-1 fa fa-check" />
                            </span>
                          ) : item?.status === "exchanged" ? (
                            <span className="bg-green-700 badge">
                              Exchanged
                            </span>
                          ) : item?.type === "exchangeFee" ? (
                            <span className="bg-green-700 badge">
                              Exchanged Fee
                            </span>
                          ) : item?.type === "voidFee" ? (
                            <span className="bg-gray-600 badge">Void Fee</span>
                          ) : (
                            <span className="badge badge-success">
                              Success
                              <span className="ms-1 fa fa-check" />
                            </span>
                          )}
                        </td>
                        <td className="py-2">
                          {moment(item.createdAt).format("MMMM Do YYYY")}
                        </td>
                        <td className="py-2">
                          {item.company?.name
                            ? item.company?.name
                            : "Deleted Company"}
                        </td>
                        <td className="py-2">{item?.transaction}</td>
                        <td>
                          {item?.ticketNumber?.map((ticket, index) => (
                            <div className="flex flex-col" key={index}>
                              {ticket}
                            </div>
                          ))}
                        </td>
                        <td className="py-2">{item.bank}</td>
                        <td className="py-2">
                          {item.deposit && item?.deposit + " birr"}
                        </td>
                        <td className="py-2">
                          {formatNumber(
                            item.amount +
                              (item?.serviceCharge || 0) +
                              (item?.NDCServiceCharge || 0) || 0
                          )}{" "}
                          birr
                        </td>
                        <td className="py-2">
                          {formatNumber(item.amount)} birr
                        </td>
                        <td className="py-2">
                          {formatNumber(item.serviceCharge || 0)} birr
                        </td>
                        <td className="py-2">
                          {formatNumber(item.NDCServiceCharge || 0)} birr
                        </td>
                        <td className="py-2">
                          {formatNumber(item.systemFee || 0)} birr
                        </td>
                        <td className="py-2">
                          {formatNumber(
                            item.serviceCharge +
                              (item.NDCServiceCharge || 0) -
                              item.systemFee || 0
                          )}{" "}
                          birr
                        </td>
                        {/* <td className="py-2">
                          {formatNumber(item.commission || 0)} birr
                        </td> */}
                        <td className="py-2">
                          {item.booking?.passengers[0]
                            ? item.booking?.passengers[0]?.firstName +
                              " " +
                              item.booking?.passengers[0]?.lastName
                            : ""}
                        </td>
                        <td>
                          {item?.type === "exchangeFee"
                            ? item?.exTicketNumber?.map((ticket, index) => (
                                <div className="flex flex-col" key={index}>
                                  {ticket}
                                </div>
                              ))
                            : item?.booking?.flight?.ticketNumber?.map(
                                (ticket, index) => (
                                  <div className="flex flex-col" key={index}>
                                    {ticket}
                                  </div>
                                )
                              )}
                        </td>
                        <td className="py-2">{item.tax || 0}</td>
                        <td className="py-2">{item.penalty || 0}</td>
                        <td className="py-2">{item.usedFare || 0}</td>
                        <td className="py-2">{item.exchangeDifference || 0}</td>
                        <td className="py-2">{item.reason}</td>
                        <td className="py-2">{item.withdrawMethod}</td>
                        <td className="py-2">{item.chequeNumber}</td>
                        <td className="py-2">{item.paidBy}</td>
                        <td className="py-2">{item.approvedBy}</td>
                        <td className="py-2">
                          {item.balance <= 0
                            ? formatNumber(item.company?.wallet.toFixed(2)) +
                              " birr"
                            : formatNumber(item.balance.toFixed(2)) + " birr"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="flex justify-center items-center my-5">
                <Pagination
                  count={Math.ceil(billings?.billings?.pagination?.total)}
                  page={currentPage}
                  onChange={handlePageChange}
                  siblingCount={4}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overall;
